import I18n from 'I18n';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { TextCell } from './TextCells';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getContentAccessTypeTagI18nKeyFromContent } from 'ui-memberships-settings-lib/utils/contentAccessTypeTag';
import { jsx as _jsx } from "react/jsx-runtime";
const AudienceAccessCell = ({
  crmObject
}) => {
  const accessRuleIds = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_IDS);
  const publicAccessRuleType = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_TYPE);
  const password = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.PASSWORD);
  const {
    i18nKey: contentAccessTypeTagI18nKey,
    accessControlType
  } = getContentAccessTypeTagI18nKeyFromContent({
    password,
    publicAccessRules: [{
      type: publicAccessRuleType,
      ids: accessRuleIds
    }],
    publicAccessRulesEnabled: publicAccessRuleType !== PublicAccessRuleTypes.PUBLIC,
    isSSOEnabled: false // TODO: fix this
  });
  return /*#__PURE__*/_jsx(TextCell, {
    value: I18n.text(contentAccessTypeTagI18nKey),
    dataTestId: `content-audience-access-${accessControlType}`
  });
};
export default AudienceAccessCell;